<template>
    <Paper>
        <div v-show='listFlag'>
            <span class="page-description">{{$translate('lang.E3202404300001', { defaultText: '条码档案查询' })}}</span>
            <i class="page-description-question el-icon-question" :data-title="pageDescription"></i>
            <div class="fileSearch">
                <el-row>
                    <el-col :span="19">
                        <el-row>
                            <el-col :span="8">
                                <div class="item firstHead">
                                    <div class="search-code">
                                        <el-input
                                            v-model="searchData['barcodeNo']"
                                            :placeholder="$translate('lang.E3202101260008', { defaultText: '条码字符串' })"
                                            @keyup.enter.native="searchChange">
                                        </el-input>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="5">
                        <div class="fileSearch-btns">
                            <el-button type="primary" :loading="searchLoading" size="mini" icon='el-icon-search' @click="searchChange"
                            >{{$translate('lang.E3202101260004', { defaultText: '查 询' })}}</el-button>
                            <el-button class="sn-search-reset-button" @click="restSearchChange" size="mini">{{$translate('lang.E3202101260009', { defaultText: '重 置' })}}</el-button>
                            <el-tooltip class="sn-search-default-button" effect="dark" content="导出" placement="bottom">
                                <reportExport #default="{ submit }" reportCode="">
                                    <el-button icon="el-icon-upload2" size="mini" @click="searchExport(submit)"></el-button>
                                </reportExport>
                            </el-tooltip>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="btnList">
                <el-button size="mini" type="primary" @click="batchOperation">
                    {{$translate('lang.E3202301040034', { defaultText: '批量查询导出' })}}
                </el-button>
            </div>
            <div class="file-search-table">
                <m-table
                    ref="RegistrationTable"
                    :pageTotal="pageTotal"
                    :tableData="listData"
                    :currentPage='currentPage'
                    @pageChange="pageChange"
                    @sizeChange="sizeChange"
                    @rowDBclick='rowDBclick'
                    :config="tableConfig">
                </m-table>
            </div>
        </div>
        <m-detail
          ref="mDetail"
          v-show='!listFlag'
          @backToList='backToList'
          :columns='tableConfig.table.columns'
        >
        </m-detail>
        <el-dialog
            :title="$translate('lang.E3202301040034', { defaultText: '批量查询导出' })"
            :visible.sync="dialogVisible"
            width="600px"
            :before-close="handleClose">
            <el-upload
                class="upload-demo"
                ref="upload"
                action=""
                :file-list="fileList"
                :auto-upload="false"
                :on-remove="handleRemove"
                :on-change="fileChange">
                <el-button size="small" type="primary">{{$translate('lang.E3202102220002', { defaultText: '上传' })}}</el-button>
            </el-upload>
            <el-collapse value='1' class="filesSearch-collapse">
                <el-collapse-item :title="$translate('lang.E2202402270012', { defaultText: '模板' })" name="1">
                    <mExport
                    :url='templateExport.exportUrl'
                    :params='templateExport.exportParams'
                    :name='templateExport.exportName'
                    :type='templateExport.type'
                    :listData='listData'
                    :linkFlag="true"
                    :exportFlag='templateExport.exportFlag'
                    :titleText='templateExport.titleText'>
                </mExport>
                </el-collapse-item>
            </el-collapse>
            <span slot="footer" class="dialog-footer">
                <reportExport #default="{ submit }" reportCode="">
                    <el-button size="small" @click="exportListFile(submit)" type="primary">
                        {{$translate('lang.E2202402030017', { defaultText: '查询导出' })}}
                    </el-button>
                </reportExport>
            </span>
        </el-dialog>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import reportExport from '@/components/lots/reportExportPlugin';
import mTable from '../../../components/IdentityComponent/Main';
import { tableConfig } from './tableConfig.js';
import mDetail from './detail';
import { searchLcbsFileData, uploadFile } from '../../../api/lcbsManagement.js';
import mExport from '../component/export';
import { dictWithUrl } from '../../../components/basicDataDialog/api';
const EXPORT_API = '/api-sn/lbcs/bcBarcode/export'; // 通用导出接口路径
const FIRE_SIZE = 1 * 1024 * 1024;// 文件大小1M
export default {
    name: 'filesSearch',
    components: { Paper, mTable, mDetail, mExport, reportExport },
    data() {
        return {
            tableConfig,
            searchData: {},
            searchLoading: false,
            listData: [],
            pageTotal: 0,
            currentPage: 1,
            templateFlie: {},
            fileList: [],
            listFlag: true,
            listExport: {
                exportUrl: '/api-sn/lbcs/bcBarcode/export',
                exportName: this.$translate('lang.E3202101260012', { defaultText: '条码档案信息查询列表.xls' }),
                exportParams: {},
                titleText: this.$translate('lang.E3202101260010', { defaultText: '导出Excel' }),
                exportFlag: 0
            },
            templateExport: {
                exportUrl: '/api-sn/lbcs/bcBarcode/templates/download',
                type: 'get',
                exportName: this.$translate('lang.E3202101260013', { defaultText: 'LBCS条码档案批量查询模板.xls' }),
                exportParams: {},
                titleText: this.$translate('lang.E3202101260014', { defaultText: '批量查询模板下载' }),
                exportFlag: 1
            },
            pageDescription: '',
            dialogVisible: false,
            listExportParams: {}
        };
    },
    methods: {
        initData() {
            this.searchData = {
                barcodeNo: ''
            };
        },
        restSearchChange() {
            this.initData();
        },
        handleSearchData() {
            const params = {
                ...this.searchData,
                pageNo: this.tableConfig.page.pageNo,
                pageSize: this.tableConfig.page.pageSize
            };
            Object.keys(params).forEach(item => {
                if (!params[item]) {
                    delete params[item];
                }
            });
            return params;
        },
        searchChange() {
            this.tableConfig.page.pageNo = 1;
            this.currentPage = 1;
            const params = this.handleSearchData();
            this.getData(params);
        },
        getData(params) {
            if (!params.barcodeNo) {
                this.$message.warning(this.$translate('lang.EXC202101250001', { defaultText: '条码字符串不能为空' }));
                return;
            };
            this.listExportParams = JSON.parse(JSON.stringify(params));
            this.searchLoading = true;
            searchLcbsFileData(params).then(res => {
                if (res.code === '0') {
                    this.listData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.searchLoading = false;
            });
        },
        fileChange(file, fileList) {
            if (fileList.length > 0) {
                this.fileList = [fileList[fileList.length - 1]];
            }
            const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
            if (testmsg !== 'xls') {
                this.$message({
                    message: this.$translate('lang.EXC202101260001', { defaultText: '表格上传类型不正确,请上传xls文件' }),
                    type: 'warning'
                });
                this.$refs.upload.clearFiles();
                this.templateFlie = {};
                this.fileList = [];
            } else {
                this.templateFlie = file;
            }
        },
        handleRemove(file) {
            this.templateFlie = {};
            this.$refs.upload.clearFiles();
        },
        pageChange(pageNo) {
            this.tableConfig.page.pageNo = pageNo;
            this.currentPage = pageNo;
            const params = this.handleSearchData();
            this.getData(params);
        },
        sizeChange(pageSize) {
            this.tableConfig.page.pageNo = 1;
            this.currentPage = 1;
            this.tableConfig.page.pageSize = pageSize;
            const params = this.handleSearchData();
            this.getData(params);
        },
        exportListFile(submit) {
            if (!this.templateFlie.name) {
                this.$message.warning(this.$translate('lang.E2202402280011', { defaultText: '请先上传文件' }));
                return;
            }
            if (this.templateFlie.size > FIRE_SIZE) {
                this.$message.warning(this.$translate('lang.E2202402280012', { defaultText: '文件大小不得超过1024KB，请修改后上传！' }));
                return;
            }
            const form = new FormData();
            form.append('file', this.templateFlie.raw);
            uploadFile(form).then(res => {
                if (res && +res.code === 0) {
                    const params = {
                        EXPORT_API,
                        barcodeBatchNo: res.data
                    };
                    this.listExport.exportFlag = 1;
                    submit(params);
                }
            });
        },
        rowDBclick(row) {
            this.listFlag = false;
            this.$refs['mDetail'].getDetail(row);
        },
        backToList() {
            this.listFlag = true;
        },
        async dictData() {
            const option = await dictWithUrl('BILL_DESC');// BILL_DESC-菜单描述
            const dictOptions = {};
            if (+option.code === 0) {
                const dictList = option.data.BILL_DESC;
                dictList.forEach(item => {
                    dictOptions[item.code] = item.name;
                });
            }
            this.pageDescription = dictOptions[this.$options.name].replace(/ {2}/g, '\n');
        },
        batchOperation() {
            this.dialogVisible = true;
        },
        handleClose() {
            this.dialogVisible = false;
            this.templateFlie = {};
            this.listExport.exportFlag = 0;
            this.$refs.upload.clearFiles();
        },
        searchExport(submit) {
            const params = {
                EXPORT_API,
                ...this.listExportParams
            };
            if (!params.barcodeNo) {
                this.$message.warning(this.$translate('lang.EXC202101250001', { defaultText: '条码字符串不能为空' }));
                return;
            };
            if (!this.listData.length) {
                this.$message.warning(this.$translate('lang.EXC202101260002', { defaultText: '暂无导出数据,请重新设置查询条件' }));
                return;
            };
            submit(params);
        }
    },
    async created() {
        await this.dictData();
    },
    mounted() {
        this.initData();
    }
};
</script>
<style lang="less" src='./index.less'>
</style>